import z from "zod";
import createSchemaUtils from "../../helpers/createSchemaUtils";

//TODO: Implement properly
export const RESTDatasourceSchema = z.object({
    endpoint: z.url().describe("The REST API endpoint URL."),
    method: z.enum(["GET", "POST", "PUT", "DELETE"]).describe("The HTTP method to use for the REST API request."),
    headers: z.record(z.string().nonempty(), z.string()).optional(),
    body: z.any().optional(),
});
export type RESTDatasource = z.infer<typeof RESTDatasourceSchema>;
export const RESTDatasource = createSchemaUtils(RESTDatasourceSchema);
